import RiveBackground from "./RiveBackground";
import React from "react";
import {Button} from "primereact/button";
import Slider from "react-slick";

export default function HeroSection(){
    let settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4500
    };
    let settingsVertical = {
        vertical: true,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4500
    };

    return(
        <div>
            {/*uncommand/command background section*/}
            {/*<RiveBackground/>*/}
            {/* --------- END RIVE BACKGROUND ----------*/}
            <div className="hero-backgrounds landing-page">
                <Slider {...settings} className="hero-slider-background">
                    <div className="hero-background-01"></div>
                    <div className="hero-background-02"></div>
                    <div className="hero-background-03"></div>
                </Slider>
            </div>
            <div className="hero">
                <div className="hero-message-wrapper landing-page">
                    <Slider {...settingsVertical} className="hero-slider-label">
                        <h1>Bangun usaha impian dengan Pinjaman Usaha<br/>
                            <p>Dapatkan akses pinjaman untuk modal usaha yang akan mendorong perkembangan bisnis Anda ke
                                level berikutnya.</p>
                        </h1>
                        <h1>Mudah, cepat & aman ajukan Kredit Multi Guna<br/>
                            <p>Nikmati kemudahan dan fleksibilitas mendapatkan pinjaman kredit dengan jaminan rumah atau
                                mobil Anda.</p>
                        </h1>
                        <h1>Mulai dari Rp 100.000 bisa Mendanai Pinjaman<br/>
                            <p>Siapapun bisa dapat keuntungan pasti melalui pendanaan pinjaman yang aktif.</p>
                        </h1>
                    </Slider>

                    <Slider {...settingsVertical} className="hero-btn-detail">
                        <Button className="btn-hero" link onClick={() => window.location = '/pinjaman-usaha'}>Pelajari
                            Lebih Lanjut</Button>
                        <Button className="btn-hero" link onClick={() => window.location = '/pinjaman-individu'}>Pelajari
                            Lebih Lanjut</Button>
                        <Button className="btn-hero" link onClick={() => window.location = '/pendanaan'}>Pelajari Lebih
                            Lanjut</Button>
                    </Slider>
                </div>
            </div>
        </div>
    );
}